const THOUSAND = 1_000;
const MILLION = 1_000_000;
const BILLION = 1_000_000_000;

const formatValue = (value: number): string => {
  const truncated = Math.floor(value * 10) / 10;

  return Number.isInteger(truncated)
    ? truncated.toString()
    : truncated.toString();
};

const formatMoneyAmountToShort = (amount: number): string => {
  const absAmount = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';

  if (absAmount < THOUSAND * 10) {
    return amount.toString();
  }

  if (absAmount < MILLION) {
    return `${sign}${formatValue(absAmount / THOUSAND)}K`;
  }

  if (absAmount < BILLION) {
    return `${sign}${formatValue(absAmount / MILLION)}M`;
  }

  return `${sign}${formatValue(absAmount / BILLION)}B`;
};

export default formatMoneyAmountToShort;
